<template>
    <v-layout justify-center>
        <v-responsive max-width="560" width="100%">
            <list-heading title="채팅상담 OpenAI 설정" />

            <v-card outlined style="overflow: hidden">
                <vertical-form-table v-model="form" v-bind="{ items }" @input="emit" style="margin-top: -1px" />
                <v-card-actions class="pa-0">
                    <v-row no-gutters align="center">
                        <v-col class="px-4">
                            <v-switch v-model="form.openai.enabled" v-bind="attrs_switch__console" @change="emit">
                                <template #label>
                                    <span class="text-caption">
                                        <template v-if="form.openai.enabled"> 사용 </template>
                                        <template v-else> 미사용 </template>
                                    </span>
                                </template>
                            </v-switch>
                        </v-col>
                        <v-spacer />
                        <v-divider vertical />
                        <v-btn text tile color="primary" height="48" v-bind="{ loading }" @click="update">
                            <v-icon small class="mr-1"> mdi-content-save </v-icon>
                            저장하기
                        </v-btn>
                    </v-row>
                </v-card-actions>
            </v-card>

            <v-fade-transition>
                <v-overlay v-show="loading" light color="white">
                    <v-progress-circular size="100" width="5" color="primary" indeterminate />
                </v-overlay>
            </v-fade-transition>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import { mapActions, mapState } from "vuex";
import { attrs_input__verticalTable, attrs_switch__console } from "@/assets/variables";
import { initCommonSetting } from "@/store/common/setting";

import ListHeading from "@/components/console/dumb/list-heading.vue";
import VerticalFormTable from "@/components/console/dumb/vertical-form-table.vue";

export default {
    components: {
        ListHeading,
        VerticalFormTable,
    },
    data: () => ({
        form: initCommonSetting(),

        loading: false,

        attrs_switch__console,
        attrs_input__verticalTable,
    }),
    computed: {
        ...mapState("common/setting", { setting: (state) => state.data }),

        items() {
            return [
                {
                    key: "openai.organization",
                    term: "Organization ID",
                    type: "text",
                },
                // {
                //     key: "openai.project",
                //     term: "Project ID",
                //     type: "text",
                // },
                {
                    key: "openai.apiKey",
                    term: "API Key",
                    type: "text",
                },
            ].map((item) => ({
                ...item,
                ...attrs_input__verticalTable,
                dense: true,
                placeholder: "값을 입력해 주세요",
                class: "text-caption",

                // vertical-form-table props
                divider: this.$vuetify.breakpoint.mdAndUp,
                rowProps: { align: "center" },
                termProps: { cols: 12, md: 3, class: "text-caption px-4 py-0" },
                dataProps: { cols: 12, md: "", class: "text-caption px-1 py-0" },
            }));
        },
    },
    methods: {
        ...mapActions("common/setting", ["getData"]),

        async init() {
            this.form = initCommonSetting();
            this.loading = false;

            this.search();
        },

        async emit() {
            this.form = initCommonSetting(this.form);
        },

        async search() {
            if (this.loading) return;
            else this.loading = true;
            try {
                await this.getData({ isConsole: true });
                this.form = initCommonSetting(this.setting);
            } finally {
                this.loading = false;
            }
        },

        async update() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { openai } = this.form;
                await api.console.setting.put({ openai });
            } finally {
                this.loading = false;
                this.search();
            }
        },
    },
    mounted() {
        this.init();
    },
};
</script>


<style lang="scss" scoped>
.vertical-table-input ::v-deep .v-input__slot {
    background: transparent !important;
    padding: 0px 16px !important;
}
</style>